<script setup lang="ts">
interface Props {
  value: number;
  digits?: null | number;
}

const store = useStore()
const { currency } = storeToRefs(store)

const { value, digits } = defineProps<Props>()

const minimumFractionDigits = computed<number>(() => {
  return unref(digits) ?? (unref(value) % 1 === 0 ? 0 : 2)
})

const formatter = usePrice(minimumFractionDigits)
</script>

<template>
  <span class="whitespace-nowrap">{{ formatter.format(value) }}&nbsp;{{ currency }}</span>
</template>